import {Address} from './address';
import {Person} from './person';

export class Company {
    name: string;
    fullName: string;
    address: Address;
    owner: Person;
    email: string;
    phone: string;
    mobile1: string;
    mobile2: string;
    mobile3: string;
    facebook: string;
    instagram: string;
    whatsapp: string;
    youtube: string;
    tiktok: string;
    twitter: string;
    twitch: string;
    fax: string;
    etsy: string;
    vimeo: string;
    pinterest: string;


    constructor() {
    }

    public createInstance(obj: {}) {
        Object.assign(this, obj);
    }
}
